import React from "react";
import { Container } from "react-bootstrap";
import img1 from "../../assets/Images/Blogs/Gemini_Generated_Image_osi2x3osi2x3osi2.jpg";
import { useIsMobile } from "../../utils/responsive";

export default function ImgHeader() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div
        style={{
          position: "relative",
          height: "50%",
          overflow: "hidden",
        }}
      >
        <img
          src={img1}
          alt="header-Img"
          style={{
            objectFit: "cover",
            width: "100%",
            height: isMobile ? "400px" : "850px",
          }}
        />

        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        ></div>

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: isMobile ? "400px" : "850px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          {!isMobile && (
            <div
              className="d-flex justify-content-center"
              style={{ height: "30%" }}
            >
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "60%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  borderLeft: "1px solid white",
                }}
              ></div>
            </div>
          )}
          <div
            className="d-flex justify-content-center"
            style={{ height: isMobile ? "5%" : "10%" }}
          >
            {!isMobile && (
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            {!isMobile && (
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            <div
              style={{
                width: isMobile ? "100%" : "60%",
                // borderTop: "1px solid black",
                borderBottom: isMobile ? "none" : "1px solid white",
                borderRight: isMobile ? "none" : "1px solid white",
                // borderLeft: "1px solid black",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h6 className="heading-xxs m-0 p-4 text-white text-uppercase text-center">
                BLOG 01 | 07.02.2025
              </h6>
            </div>
            {!isMobile && (
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            {!isMobile && (
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  borderLeft: "1px solid white",
                }}
              ></div>
            )}
          </div>
          <div
            className="d-flex justify-content-center"
            style={{ height: isMobile ? "15%" : "25%" }}
          >
            {!isMobile && (
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            {!isMobile && (
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            <div
              style={{
                width: isMobile ? "100%" : "60%",
                // borderTop: "1px solid black",
                borderBottom: isMobile ? "none" : "1px solid white",
                borderRight: isMobile ? "none" : "1px solid white",
                // borderLeft: "1px solid black",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h3 className="heading-sm m-0 p-4 text-white text-uppercase text-center">
                timeless elegance, colonial charm
              </h3>
            </div>
            {!isMobile && (
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            {!isMobile && (
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  borderLeft: "1px solid white",
                }}
              ></div>
            )}
          </div>
          <div
            className="d-flex justify-content-center"
            style={{ height: isMobile ? "10%" : "15%" }}
          >
            {!isMobile && (
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            {!isMobile && (
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            <div
              style={{
                width: isMobile ? "100%" : "60%",
                // borderTop: "1px solid black",
                borderBottom: isMobile ? "none" : "1px solid white",
                borderRight: isMobile ? "none" : "1px solid white",
                // borderLeft: "1px solid black",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h6 className="heading-xxs m-0 p-4 text-white text-uppercase text-center">
                A Victorian Tale in Every Detail
              </h6>
            </div>
            {!isMobile && (
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  // borderLeft: "1px solid black",
                }}
              ></div>
            )}
            {!isMobile && (
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  borderLeft: "1px solid white",
                }}
              ></div>
            )}
          </div>
          {!isMobile && (
            <div
              className="d-flex justify-content-center"
              style={{ height: "30%" }}
            >
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  // borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  // borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "60%",
                  // borderTop: "1px solid black",
                  // borderBottom: "1px solid white",
                  borderRight: "1px solid white",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "15%",
                  // borderTop: "1px solid black",
                  // borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  // borderLeft: "1px solid black",
                }}
              ></div>
              <div
                style={{
                  width: "5%",
                  // borderTop: "1px solid black",
                  // borderBottom: "1px solid white",
                  // borderRight: "1px solid black",
                  borderLeft: "1px solid white",
                }}
              ></div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
}
